/**
 * @generated SignedSource<<fb5dd545f5899fe3c7e04cef6fbf45cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DiagnosticProjectedStatus = "AHEAD" | "AT_RISK" | "ON_TRACK" | "%future added value";
export type IndividualStudentReportOverallQuery$variables = {
  userId: string;
};
export type IndividualStudentReportOverallQuery$data = {
  readonly IndividualReportOverview: {
    readonly currentPace: any;
    readonly demonstratedSkillsInDiagnostic: number;
    readonly demonstratedSkillsSinceDiagnostic: number;
    readonly diagnosticDate: any;
    readonly projectedPercentageCurrentPace: number | null | undefined;
    readonly projectedPercentageFourSkillsPace: number | null | undefined;
    readonly projectedPercentageThreeSkillsPace: number | null | undefined;
    readonly projectedPercentageTwoSkillsPace: number | null | undefined;
    readonly projectedStatusCurrentPace: DiagnosticProjectedStatus | null | undefined;
    readonly projectedStatusFourSkillsPace: DiagnosticProjectedStatus | null | undefined;
    readonly projectedStatusThreeSkillsPace: DiagnosticProjectedStatus | null | undefined;
    readonly projectedStatusTwoSkillsPace: DiagnosticProjectedStatus | null | undefined;
    readonly roadmapSkills: number;
    readonly studentWillCompleteDate: any | null | undefined;
  };
};
export type IndividualStudentReportOverallQuery = {
  response: IndividualStudentReportOverallQuery$data;
  variables: IndividualStudentReportOverallQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": "IndividualReportOverview",
    "kind": "LinkedField",
    "name": "IndividualReportOverview",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "diagnosticDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "demonstratedSkillsInDiagnostic",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "demonstratedSkillsSinceDiagnostic",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "roadmapSkills",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "studentWillCompleteDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentPace",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectedStatusCurrentPace",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectedStatusTwoSkillsPace",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectedPercentageTwoSkillsPace",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectedStatusThreeSkillsPace",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectedPercentageThreeSkillsPace",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectedStatusFourSkillsPace",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectedPercentageFourSkillsPace",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectedPercentageCurrentPace",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IndividualStudentReportOverallQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IndividualStudentReportOverallQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8411b921dd48dc37f3ebb8971869790d",
    "id": null,
    "metadata": {},
    "name": "IndividualStudentReportOverallQuery",
    "operationKind": "query",
    "text": "query IndividualStudentReportOverallQuery(\n  $userId: ID!\n) {\n  IndividualReportOverview(userId: $userId) {\n    diagnosticDate\n    demonstratedSkillsInDiagnostic\n    demonstratedSkillsSinceDiagnostic\n    roadmapSkills\n    studentWillCompleteDate\n    currentPace\n    projectedStatusCurrentPace\n    projectedStatusTwoSkillsPace\n    projectedPercentageTwoSkillsPace\n    projectedStatusThreeSkillsPace\n    projectedPercentageThreeSkillsPace\n    projectedStatusFourSkillsPace\n    projectedPercentageFourSkillsPace\n    projectedPercentageCurrentPace\n  }\n}\n"
  }
};
})();

(node as any).hash = "c6309afd0a327d9ee782292b21e9faae";

export default node;
